import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { coverageVendorServiceConfigSchema } from '../configurations/CoverageVendorServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderCoverageVendorDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.COVERAGE_VENDOR]: coverageVendorServiceConfigSchema,
    }),
});

export { servicesProviderCoverageVendorDataSchema };
//# sourceMappingURL=ServicesProviderCoverageVendorData.js.map
